import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6980e578"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "content",
  class: "content",
  itemscope: "",
  itemtype: "https://schema.org/Person"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polygon", { points: "30,70.3 70,54.3 70,45.7 30,29.7 30,38.3 59.2,50 30,61.7  " }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { itemprop: "name" }, "Bento", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { itemprop: "jobTitle" }, "Frontend Developer", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_circle = _resolveComponent("icon-circle")!
  const _component_contact = _resolveComponent("contact")!
  const _component_css_doodle = _resolveComponent("css-doodle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("header", null, [
        _createElementVNode("button", {
          class: _normalizeClass(["non-button", { 'non-button--disabled': _ctx.isBackgroundActive }]),
          type: "button",
          disabled: _ctx.isBackgroundActive,
          "aria-label": "change background",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleBackgroundDoodle())),
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCircleActive = true)),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.isBackgroundActive && (_ctx.isCircleActive = false)))
        }, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["non-button-text", {
            'non-button-text--active': _ctx.isCircleActive || _ctx.isBackgroundActive,
          }]),
            fill: "currentColor",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            version: "1.1",
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            style: {"enable-background":"new 0 0 100 100"},
            "xml:space": "preserve"
          }, _hoisted_4, 2)),
          _createVNode(_component_icon_circle, {
            isActive: _ctx.isCircleActive || _ctx.isBackgroundActive,
            class: "non-button-circle"
          }, null, 8, ["isActive"])
        ], 42, _hoisted_2),
        _hoisted_5,
        _hoisted_6
      ]),
      _createVNode(_component_contact)
    ], 512),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.isBackgroundActive)
          ? (_openBlock(), _createElementBlock("button", {
              "aria-live": "polite",
              "aria-label": "change background",
              tabindex: "-1",
              key: "poster",
              class: "doodle-wrapper",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleBackgroundDoodle()))
            }, [
              _createVNode(_component_css_doodle, {
                onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (!_ctx.reduceMotion && _ctx.updateDoodle())),
                onMouseleave: _ctx.clearDoodle,
                class: "doodle",
                ref: "doodle"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("pre", null, "          :doodle {\n            @grid: 8 / 90%;\n            @shape: circle;\n          }\n          border-radius: @pick(100% 0, 0 100%);\n          transform: scale(@r(.25, 1.25));\n          background: hsla(calc(240 - 6 * @x * @y), 70%, 68%, @r.8 );\n          transition: " + _toDisplayString(_ctx.reduceMotion ? 0 : ".4s @r(.6s)") + " ;\n        ", 1)
                ]),
                _: 1
              }, 8, ["onMouseleave"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}